import { useEffect } from 'react'

/**
 * Hook that handles clicks outside of the passed ref
 */
export default function useOutsideClick(ref: any, func: any) {
  useEffect(() => {
    /**
     * Handle if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        func()
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref])
}
